<form (ngSubmit)="submit()" novalidate [formGroup]="form">
  <div class="use-coupon">

    <div class="toggle">
      <div class="heading"> <span class="Textresized" style="color: black;">{{'Checkout.ApplyCoupon' | translate}}</span></div>
      <div class="togglebutton">

        <ion-item >
          @if (toggleInput) {
            <span class="Textresized">{{'General.Yes' | translate}}</span>
          }
          @if (!toggleInput) {
            <span class="Textresized">{{'General.No' | translate}}</span>
          }
          <ion-toggle style="padding: 5px; max-width: 31px;" (ionChange)="applyCoupon()" [checked]="toggleInput">
          </ion-toggle>
        </ion-item>

      </div>
    </div>

    @if (toggleInput) {
      <ion-item>
        <ion-input class="Textresized adjustMinHeight" formControlName="couponNumber"  placeholder="{{'Checkout.CouponNumber' | translate}}" style="background: whitesmoke; border: 1px solid lightgrey;"></ion-input>

        <ion-button  class="checkoutButton" type="submit" [disabled]="!form.valid">{{ 'Checkout.ValidateGiftCard' | translate }}</ion-button>
        <ion-button class="checkoutButton" (click)="viewOffers()">{{'Checkout.SearchCoupons' | translate}}</ion-button>
      </ion-item>
    }
    
    @if (discountResponse) {
      @if (!error) {
        <ion-item>
          <ion-label>{{'Checkout.UseCouponToPay' | translate}}</ion-label>
          @if (discountAmount.amount ) {
            <ion-label style="text-align: right;">-{{ discountAmount.amount | currency }}</ion-label>
          }
          <!-- <ion-label style="text-align: right;" *ngIf="!discountAmount.amount ">Invalid Coupon</ion-label> -->
        </ion-item>
      }
      @if (!error) {
        <ion-item>
          <ion-label style="font-weight: bold; color:green;">{{'Checkout.UseCouponClickToPay' | translate}}</ion-label>
          <ion-label style="text-align: right;font-weight: bold;">{{ (subtotal-discountAmount.amount) | currency }}</ion-label>
        </ion-item>
      }
      @if (error && couponError) {
        <ion-item>
          <ion-label style="color:red">{{couponError}}</ion-label>
        </ion-item>
      }
    }


  </div>

</form>